import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  Alert,
  Button,
  Col,
  Form,
  Row,
} from "react-bootstrap";
import axios from "axios";
import { Prompt, useHistory } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import { MedicAssignationTraking } from "../../subPages/MedicAssignationTracking/MedicAssignationTracking";
import { MedicalFees } from "../../subPages/MedicalFee/MedicalFees";
import AuthLetters from "../../subPages/AuthLetter/AuthLetters";
import {
  getBySlug,
  update,
} from "../../services/hospitalizationcrud";
import { getLasMcMovementtByCase } from "../../services/mcMovementsService";
import { isEmpty } from "../../../_utils/checkObjectEmpty";
import moment from "moment";
import { RegistrationCaseType } from '../../../helpers/constants';
import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import BlockCaseContext from "../../../contexts/BlockCaseContext";
import $ from "jquery";

const ControlDeskDetails = (props) => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Mesa de Control");

  const { slug } = props.match.params;

  const [caseRecord, setCaseRecord] = useState({});
  const [mcMovement, setMcMovement] = useState({});
  const [hasValidationSchema, setHasValidationSchema] = useState(true);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);
  const [shouldIgnoreLeaveMessage, setShouldIgnoreLeaveMessage] = useState(false);
  const [folioIh, setFolioIh] = useState("");
  const [savingFolioIh, setSavingFolioIh] = useState(false);

  let history = useHistory();
  const inputReasonTracing = useRef();
  const inputReasonMedicInformation = useRef();

  let submitFormMedicAssignation = null;
  let submitFormMedicAssignationErrors = null;

  const bindSubmitFormMedicAssignation = (submitForm) =>
    (submitFormMedicAssignation = submitForm);

  const bindSubmitFormMedicAssignationErrors = (errors) =>
    (submitFormMedicAssignationErrors = errors);

  useEffect(() => {
    window.wasCommented = false;
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      setFolioIh(response.data.folioIh || "");
      updateCaseWorking(response.data.id, 1);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovemet) =>
        setMcMovement(currentMcMovemet.data)
      );
    });
  }, [slug]);

  window.onbeforeunload = function() {
    if (!shouldBlockCase) {
      updateCaseWorking(caseRecord.id, 0);
      return;
    }

    updateCaseLocked();
  }

  const updateCaseLocked = () => {
    if (!window.wasCommented || shouldBlockCase)
      update({ caseLocked: 1 }, caseRecord.id).then((response) => console.log("Caso bloqueado..."));
  }

  const updateCaseWorking = (caseId, caseWorkingValue) => {
    update({ caseWorking: caseWorkingValue }, caseId).then((response) => console.log("El caso se esta trabajando..."));
  }

  const getHospitalDateHire = (timestamp) => {
    if (RegistrationCaseType.includes(caseRecord.caseType) && !caseRecord.hospitalDateHire) {
      return moment.utc(timestamp.data).format();
    }
    return null;
  }

  const onSaveFolioIH = () => {
    if (!folioIh.trim()) {
      alert("Debe ingresar el Folio IH");
      return;
    }
    setSavingFolioIh(true);
    update({ folioIh: folioIh.trim() }, caseRecord.id)
      .then(() => {
        setCaseRecord((prev) => ({ ...prev, folioIh: folioIh.trim() }));
      })
      .catch(() => {
        alert("Error al guardar el Folio IH");
      })
      .finally(() => {
        setSavingFolioIh(false);
      });
  };

  const validateFolioIH = () => {
    if (!caseRecord.folioIh) {
      alert("Debe capturar y guardar el Folio IH antes de continuar");
      return false;
    }
    return true;
  };

  const onClickSendDictum = async () => {
    if (!validateFolioIH()) return;
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      let timestamp = await axios.get("/cases/localDateTime");

      update({
        caseStatusId: 5,
        feadictamen: moment.utc(timestamp.data).format(),
        hospitalDateHire: getHospitalDateHire(timestamp.data),
        caseWorking: 0,
        caseLocked: 0,
      },caseRecord.id)
      .then((response) => {
        setShouldIgnoreLeaveMessage(true);
        history.push("/mesa_control");
      });
    }
  }

  const onClickSendTraking = async () => {
    if (!validateFolioIH()) return;
    setHasValidationSchema(false);
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      let reason_sendToSeguimiento = document.getElementById(
        "reason_sendToSeguimiento"
      ).value;
      if (reason_sendToSeguimiento === "") {
        alert("Selecciona una razon para enviar a seguimiento");
        return;
      }

      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      let timestamp = await axios.get("/cases/localDateTime");

      if (caseRecord.axaCategories === "" || !caseRecord.axaCategories) {
        update(
          {
            caseStatusId: 3,
            tracingReason: reason_sendToSeguimiento,
            feaseguimiento: moment.utc(timestamp.data).format(),
            caseType: "Seguimiento",
            caseWorking: 0,
            caseLocked: 0,
          },
          caseRecord.id
        ).then((response) => {
          setShouldIgnoreLeaveMessage(true);
          history.push("/mesa_control");
        });
      } else {
        update(
          {
            caseStatusId: 3,
            tracingReason: reason_sendToSeguimiento,
            feaseguimiento: moment.utc(timestamp.data).format(),
            caseWorking: 0,
            caseLocked: 0,
          },
          caseRecord.id
        ).then((response) => {
          setShouldIgnoreLeaveMessage(true);
          history.push("/mesa_control");
        });
      }
    }
  }

  const onClickSendMedicInformation = async () => {
    let reason_sendToMedicInformation = document.getElementById(
      "reason_sendToMedicInformation"
    ).value;
    if (reason_sendToMedicInformation === "") {
      alert("Debe seleccionar una razon");
      return;
    }

    if (!window.wasCommented) {
      alert("Debe ingresar un comentario");
      return;
    }

    $("#btn_save_comment").click();
    let timestamp = await axios.get("/cases/localDateTime");

    if (caseRecord.axaCategories === "" || !caseRecord.axaCategories) {
      update(
        {
          caseStatusId: 4,
          informationReason: reason_sendToMedicInformation,
          feaimedica: moment.utc(timestamp.data).format(),
          caseType: "Seguimiento",
          caseWorking: 0,
          caseLocked: 0,
        },
        caseRecord.id
      ).then((response) => {
        setShouldIgnoreLeaveMessage(true);
        history.push("/mesa_control");
      });
    } else {
      update(
        {
          caseStatusId: 4,
          informationReason: reason_sendToMedicInformation,
          feaimedica: moment.utc(timestamp.data).format(),
          caseWorking: 0,
          caseLocked: 0,
        },
        caseRecord.id
      ).then((response) => {
        setShouldIgnoreLeaveMessage(true);
        history.push("/mesa_control");
      });
    }
  }

  const onClickSendHospital = async () => {
    if (!validateFolioIH()) return;
    await submitFormMedicAssignation();
    if (isEmpty(submitFormMedicAssignationErrors)) {
      let reason_sendToSeguimiento = document.getElementById(
        "reason_reconsideration"
      ).value;
      if (reason_sendToSeguimiento === "") {
        alert("Selecciona una razon para enviar a hospital");
        return;
      }

      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      update(
        { caseStatusId: 7, reasonReconsideration: reason_sendToSeguimiento, caseWorking: 0, caseLocked: 0 },
        caseRecord.id
      ).then((response) => {
        setShouldIgnoreLeaveMessage(true);
        history.push("/mesa_control");
      });
    }
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Mesa de Control
      </Alert>

      <Prompt
        message={(location, action) => {
          if (action === "PUSH" && !shouldIgnoreLeaveMessage) {
            if (!window.confirm("Desea salir de la Solicitud en Gestión?")) {
              return false;
            }
            updateCaseWorking(caseRecord.id, 0);
            //updateCaseLocked();
          }

          return true;
        }}
      />

      <CaseHeader
        caseRecord={caseRecord}
        hideComprehensiveCare={true}
        hideRequiresTabulation={true}
        hideHospitalModel={true}
        showFolioEp={true}
        showPolicy={true}
        folioIhSlot={
          caseRecord.folioIh ? (
            <>
              <b>Folio IH: </b>
              {caseRecord.folioIh}
              <br />
            </>
          ) : (
            <>
              <b>Folio IH: </b>
              <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
                <Form.Control
                  type="text"
                  placeholder="Ingrese Folio IH"
                  value={folioIh}
                  onChange={(e) => setFolioIh(e.target.value)}
                  style={{ width: "200px", display: "inline-block" }}
                  size="sm"
                />
                <Button
                  size="sm"
                  variant="primary"
                  onClick={onSaveFolioIH}
                  disabled={savingFolioIh}
                >
                  {savingFolioIh ? "Guardando..." : "Guardar"}
                </Button>
              </div>
              <br />
            </>
          )
        }
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
        <Accordion defaultActiveKey="0" className="mt-5">
          <InssuredData
            icon="fa-search"
            eventKey="1"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <HospitalData
            icon="fa-search"
            eventKey="2"
            data={caseRecord}
            disabledAll={true}
            bindSubmitForm={() => {}}
          />
          <Documentation data={caseRecord} icon="fa-search" eventKey="4" allowSelectiveDownload={true} {...props} />
          <MedicalFees
            icon="fa-search"
            icone="fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            hideBtnInsurance={false}
            hideFormCreate={true}
            showForm={true}
            {...props}
          />
          <AuthLetters
            icon="fa-search"
            showForm={false}
            hideDeleteOption={true}
            eventKey="3"
            data={caseRecord}
            disabledAll={false}
            setTotalLetters={() => {}}
            {...props}
          />
          <MedicAssignationTraking
            icon="fa-pencil-alt"
            eventKey="0"
            data={caseRecord}
            mcMovement={mcMovement}
            eventStage="Mesa de Control"
            bindSubmitForm={bindSubmitFormMedicAssignation}
            bindErrors={bindSubmitFormMedicAssignationErrors}
            hasValidationSchema={hasValidationSchema}
            zurichMode={true}
            hideComprehensiveCare={true}
            hideReassignment={true}
            hideReassignmentMotive={true}
            autoAssignNurseFromDoctor={true}
          />
        </Accordion>
        <Accordion defaultActiveKey="5" className="mt-5">
          <Binnacle
            icon="fa-pencil-alt"
            eventKey="5"
            data={caseRecord}
            eventStage="Mesa de Control"
            {...props}
          />
        </Accordion>
      </BlockCaseContext.Provider>

      {caseRecord.caseStatusId === 2 ? (
        <Row className="mt-5" style={{ justifyContent: "space-between" }}>
          <Col xs="auto">
            <Button variant="danger" onClick={onClickSendMedicInformation}>
              Enviar a Informacion Médica Hospital
            </Button>

            <Form.Control
              className="mt-3"
              as="select"
              name="reason_sendToMedicInformation"
              id="reason_sendToMedicInformation"
              ref={inputReasonMedicInformation}
            >
              <option value="">Selecciona una opcion...</option>
              <option value="Recibido">Recibido</option>
              <option value="Correccion de Datos">Corrección de Datos</option>
            </Form.Control>
          </Col>

          <Col xs="auto">
            <Button
              variant="success"
              onClick={onClickSendDictum}
            >
              Enviar a Dictamen
            </Button>
          </Col>
        </Row>
      ) : (
        <Row className="mt-5" style={{ justifyContent: "space-between" }}>
          <Col xs="auto">
            <Button variant="warning" onClick={onClickSendHospital}>
              Enviar a Hospital
            </Button>

            <Form.Control
              className="mt-3"
              as="select"
              name="reason_reconsideration"
              id="reason_reconsideration"
            >
              <option value="">Selecciona una opcion...</option>
              <option value="Rechazo definitivo">Rechazo definitivo</option>
            </Form.Control>
          </Col>

          <Col xs="auto">
            <Button
              variant="success"
              onClick={onClickSendDictum}
            >
              Enviar a Dictamen
            </Button>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ControlDeskDetails;
